import Swiper, { Navigation } from 'swiper';

Swiper.use([Navigation]);

export default (id = 0) => ({

    init() {
        var swiper = new Swiper(this.$refs['itemsSlider-' + id], {
            spaceBetween: 16,
            slidesPerView: 'auto',
            navigation: {
                nextEl: `.swiper-button-next-${id}`,
                prevEl: `.swiper-button-prev-${id}`,
            },
            breakpoints: {
                1024: {
                    spaceBetween: 20,
                    slidesPerView: 3,
                },
                1280: {
                    slidesPerView: 4,
                }
            }
        });
    }
})
